$(document).ready(function() {
  
  $(".cart").validate({
    submitHandler: function(form) {
      form.submit();
    },
    ignore: ".ignoretvz"
  });
  
  $(".limit-three").each(function() {
    $(this).rules('add', {
      required: true,
      max: 3,
      messages: {
        max: "Limited to 3"
      }
    });
  });
  $(".limit-five").each(function() {
    $(this).rules('add', {
      required: true,
      max: 5,
      messages: {
        max: "Limited to 5"
      }
    });
  });
});